import { Component, OnInit, ViewChild } from '@angular/core';
import { CurrencyPipe, DatePipe, formatDate } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { CustomerService } from '../_services/customer.service';
import { DebtorService } from '../_services/debtor.service';
import { MatSort, MatPaginator, MatTableDataSource } from '@angular/material';
import { AppConfig, ExcelService, PreviousRouteService } from '../_helpers/index';
import { ParameterData } from '../_helpers/index';
import { ActivatedRoute, Router } from '@angular/router';
import { DataService } from '../_helpers/dataservice.service'
import { BackFilterService, ExcelDateConvertService, PaymentProcessService } from '../_services';
import { PaymentProcess, paymentRelated } from '../_models';
import { PaymentCreation, PaymentStatus, PaymentType } from '../_enums/payment';
import { BatchProcessUrls } from '../_enums/urls';
import { AuthService } from '../_services/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { QueryParamsReportsPayemtsList } from "../_models/queryparamslist.interface";
import { PaymentProperties } from "../_models/paymentProperties.interface";
import { PaymentReportExport } from "../_models/paymentReportExport.interface";
import { AccountTypeOptions } from '../sharedcomp/constans/routes.constans';
@Component({
  selector: 'paymentlistreport',
  templateUrl: './paymentlistreport.component.html',
  styleUrls: ['../../assets/css/customer-list-table.css']
})

export class PaymentListReportComponent implements OnInit {

  public customer_public_id: string;

  excelExportData: any;
  excelExporSize: any;
  public pageStartDate: any;
  public pageEndDate: any;

  excelExportDataNew: any;

  currentDate: Date;
  startDate: Date;
  endDate: Date;


  ddlCustomerAccount: any[];
  ddlPaymentCreation: any[];
  ddlPaymentStatus: any[];
  ddlCustomerAccounts: any[];
  ddlPaymentType: any[];
  paymentPSP: any = false;

  searchFilterForm: FormGroup;
  searchRangoFilterForm: FormGroup;
  displayedColumns: string[] = ['created', 'reference', 'customer.name', 'invoice_list.0.external_id', 'invoice_list.0.name', 'invoice_list.0.sub_total.value', 'invoice_list.0.late_fee.value', 'invoice_list.0.total.value', 'metadata.psp_account.name','metadata.type','actions'];
  dataSourcePaymentsList = new MatTableDataSource();
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  filterValue;
  isRangoVisiable = false;
  auth0Profile: any;
  isLoading = true;
  pageSize: number;
  pageIndex: number = 0;
  pageStart: number = 0;
  PageSizeOptions: number[];
  offsetTimeZone: any;
  offsetMinutes: any;
  offsetTimeVal: any;
  searchValue = '';
  Operation = '';
  payment_related: paymentRelated;
  @ViewChild('close') close;
  operationDropdownValue = 0;
  creationDropdownValue = 3;
  operationFormControl = new FormControl(0);
  creationFormControl = new FormControl(3);
  tempSearch: any;
  backToSearchSharedData: any;
  previousUrl: any;
  isBrowserBackButtonPressed: boolean = false;
  queryParams: QueryParamsReportsPayemtsList = {};
  snapshotQueryParam: QueryParamsReportsPayemtsList = {};
  startDateFromSnapshotQueryParam: boolean = false;
  endDateFromSnapshotQueryParam: boolean = false;
  baseURL: string;
  timerId: any;
  isExportDataAvailable: PaymentReportExport | undefined;
  isErrorExportAvailable: object | undefined;
  timeCompleted: boolean = false;
  exportSubscription$ : Subscription;
  configurationDetails: PaymentProperties;
  isExportTemplateNotAvailable = true;
  export_templates = [];
  designVersion: string;


  constructor
    (
      private customerService: CustomerService, private formBuilder: FormBuilder
      , private _fb: FormBuilder
      , private excelService: ExcelService, private parameterData: ParameterData
      , private router: Router, private debtorService: DebtorService
      , private dataService: DataService, private paymentProcessService: PaymentProcessService
      , private paymentCreation: PaymentCreation, private paymentStatus: PaymentStatus
      , private datePipe: DatePipe
      , private auth: AuthService
      , private spinnerService: Ng4LoadingSpinnerService
      , private paymentType: PaymentType
      , private backFilterService: BackFilterService
      , private previousRouteService: PreviousRouteService
      , private currencyPipe: CurrencyPipe
      , private excelDateConvertService: ExcelDateConvertService
      , private activatedRoute: ActivatedRoute
    ) {
    this.spinnerService.show();

    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;

    this.isRangoVisiable = false;
    this.ddlPaymentCreation = paymentCreation._creation;
    this.ddlPaymentStatus = paymentStatus._status;
    this.ddlPaymentType = paymentType._type;
    this.backFilterService.getPaymentSearchSharedData().subscribe(data => this.backToSearchSharedData = data);
    this.backFilterService.getIsBrowserBackButtonPressedSharedData().subscribe(data => this.isBrowserBackButtonPressed = data);
   
    this.designVersion = localStorage.getItem('designVersion');
    if (this.designVersion === 'V2') {
      this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V2;
    } else {
      this.baseURL = AppConfig.settings.apiServer.baseURL + BatchProcessUrls.URL_BATCHES_V1;
    }
  }




  ngOnInit() {
    var browserStorage;
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      }
      else {
        this.customer_public_id = localStorage.getItem('companyId');

      }
    }
    else {
      this.customer_public_id = localStorage.getItem('subcompanyId');

    }

    browserStorage = (typeof localStorage === 'undefined') ? null : localStorage;
    this.offsetTimeZone = (typeof browserStorage.getItem('timezone') === 'undefined') ? null : browserStorage.getItem('timezone');

    if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {
      this.offsetTimeZone = -5.00;
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    else {
      this.offsetTimeZone = browserStorage.getItem('timezone');
      this.offsetMinutes = 0;
      this.offsetTimeVal = (this.offsetTimeZone * 3600000);

      AppConfig.settings.userSetting.defaultTimeZone = this.offsetTimeVal;
    }
    // }
    //////////////////////////

    this.getCustomerAccountList();
    this.getCustomerPayment();
    this.getConfigurationDetails();

    this.searchRangoFilterForm = this._fb.group({
      searchFromDate: [''],
      searchToDate: ['']
    });

    if (this.paymentCreation._creation.length > 8) {
      this.paymentCreation._creation.shift();
    }

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";

    this.pageStartDate = this.setTodayValueFilter('00:00:00');
    this.pageEndDate = this.setTodayValueFilter('23:59:59');

    //back to search start
    this.previousUrl = this.previousRouteService.getPreviousUrl();

    let route = "";
    const application = localStorage.getItem('application');
    if (AccountTypeOptions[application] != undefined) {
      route = AccountTypeOptions[application];
    }

    if ((this.isBrowserBackButtonPressed == true) &&
      (this.previousUrl.includes(`/${route}/invoices/`) || this.previousUrl.includes("/customers/")) &&
      (this.previousUrl.includes("/edit") || this.previousUrl.includes("/view"))
    ) {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.setBackToSearchData();
    } else {
      this.backFilterService.setIsBrowserBackButtonPressedSharedData(false);
      this.backFilterService.setPaymentSearchSharedData(null);
    }
    //back to search end

    this.searchFilterForm = this.formBuilder.group({
      searchText: [this.searchValue, Validators.required]
    });

    this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, this.pageStart, this.searchValue, this.Operation);

  }//end

  getConfigurationDetails() {
    this.paymentProcessService.getConfigurationDetails(this.customer_public_id).subscribe(data => {
      this.configurationDetails = data;
      if (this.configurationDetails != null && this.configurationDetails != undefined) {
        if (this.configurationDetails.values.export_templates != null && this.configurationDetails.values.export_templates != undefined) {
          if (Array.isArray(this.configurationDetails.values.export_templates)) {
            this.isExportTemplateNotAvailable = false;
            this.export_templates = this.configurationDetails.values.export_templates;
          }
        }
      }
    }, err => {
      console.log('Failed while trying to get configuration details.' + err.error);
    })
  }

  setTodayValueFilter(hour: string) {
    var currentDate = new Date();
    currentDate.setDate(currentDate.getDate());
    var todaySelectedHour = new Date(formatDate(currentDate, `yyyy-MM-dd ${hour}`, 'en-US'));
    let todayDate = this.convertGMTTime(todaySelectedHour);
    return todayDate;
  }


  setBackToSearchData() {
    if (this.backToSearchSharedData != null) {
      this.searchValue = this.backToSearchSharedData.search;
      this.operationFormControl.setValue(this.backToSearchSharedData.operationDropdownValue);
      this.creationFormControl.setValue(this.backToSearchSharedData.creationDropdownValue);
      this.operationDropdownValue = this.backToSearchSharedData.operationDropdownValue;
      this.creationDropdownValue = this.backToSearchSharedData.creationDropdownValue;
      this.Operation = this.backToSearchSharedData.operation;
      this.pageSize = this.backToSearchSharedData.pageSize;
      this.pageIndex = this.backToSearchSharedData.pageIndex;
      this.pageStart = this.backToSearchSharedData.pageStart;
      this.paginator.pageIndex = this.pageIndex;
      if (this.backToSearchSharedData.creationDropdownValue == 8) {
        this.searchRangoFilterForm = this._fb.group({
          searchFromDate: [this.backToSearchSharedData.searchFromDate],
          searchToDate: [this.backToSearchSharedData.searchToDate]
        });
        this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
        this.ddlPaymentCreation.unshift({ value: 8, name: this.filterValue });
        this.isRangoVisiable = false;
        this.pageStartDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US')));
        this.pageEndDate = this.convertGMTTime(new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US')));
        this.creationFormControl.setValue(8);
        this.creationDropdownValue = 8;
      } else {
        this.pageStartDate = this.backToSearchSharedData.creationStartDate;
        this.pageEndDate = this.backToSearchSharedData.creationEndDate;
      }
      this.setBackToSearchFilter();
    }
  }

  applyFilter() {
    this.filterValue = this.searchFilterForm.controls.searchText.value;
    this.filterValue = this.filterValue.trim();
    this.searchValue = this.filterValue;
    this.getPaymentListFilterAndSearch();
  }//end


  getProperty = (obj, path) => (
    path.split('.').reduce((o, p) => o && o[p], obj)
  )

  ngAfterViewInit() {
    this.dataSourcePaymentsList.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
    this.dataSourcePaymentsList.sort = this.sort;
  }

  getCustomerPaymentsListNew(customerId: string, startDate: string, endDate: string, limit: number, start: number, search: string, operation: string) {
    this.snapshotQueryParam = this.activatedRoute.snapshot.queryParamMap['params'];
    if (Object.entries(this.snapshotQueryParam).length != 0) {

      let creationStateReportsPaymentsList = JSON.parse(localStorage.getItem('creationStateReportsPaymentsList'));
      let customCreationReportsPaymentsRange = localStorage.getItem('customCreationReportsPaymentsRange');

      if (this.snapshotQueryParam["pageIndex"] != undefined) {
        if (this.snapshotQueryParam["pageIndex"] != '') {
          this.queryParams.pageIndex = this.snapshotQueryParam["pageIndex"];
        } else {
          this.queryParams.pageIndex = this.pageIndex;
        }
      };

      if (this.snapshotQueryParam["pageSize"] != undefined) {
        if (this.snapshotQueryParam["pageSize"] != '') {
          this.queryParams.pageSize = this.snapshotQueryParam["pageSize"];
        } else {
          this.queryParams.pageSize = this.pageSize;
        }
      };

      if (this.snapshotQueryParam["startDate"] != undefined || this.snapshotQueryParam["endDate"] != undefined) {
        if (this.snapshotQueryParam["startDate"] != '') {
          this.startDateFromSnapshotQueryParam = true;
          this.queryParams.startDate = this.snapshotQueryParam["startDate"].replace(' ', '-');
        } else {
          this.queryParams.startDate = this.pageStartDate;
        }

        if (this.snapshotQueryParam["endDate"] != '') {
          this.endDateFromSnapshotQueryParam = true;
          this.queryParams.endDate = this.snapshotQueryParam["endDate"].replace(' ', '-');
        } else {
          this.queryParams.endDate = this.pageEndDate;
        }

        if (creationStateReportsPaymentsList === 8) {
          this.creationFormControl.setValue(8);
          this.ddlPaymentCreation.unshift({ value: 8, name: customCreationReportsPaymentsRange });
        } else {
          this.creationFormControl.setValue(creationStateReportsPaymentsList);
        };
      };

      if (this.snapshotQueryParam["type"] != undefined) {
        this.queryParams.type = this.snapshotQueryParam["type"];
        this.setTypeFormBySnapshotQueryParam(this.queryParams.type);
      };

      if (this.snapshotQueryParam["textSearch"] != undefined && this.snapshotQueryParam["textSearch"] != '') {
        this.queryParams.textSearch = this.snapshotQueryParam["textSearch"];
        this.searchFilterForm.get('searchText').setValue(this.queryParams.textSearch);
      };

      this.pageEvent(this.queryParams);
    } else {
      this.spinnerService.show();
      localStorage.setItem('creationStateReportsPaymentsList', '3');
      this.paymentProcessService.getPaymentProcessReportListNew(customerId, startDate, endDate, limit, start, search, operation).subscribe(data => {
        let resourcesReturn = data["data"];
        this.excelExporSize = data["records"];
        this.dataSourcePaymentsList.data = resourcesReturn;
        this.excelExportData = resourcesReturn;
        this.spinnerService.hide();
      }, error => {
        this.isLoading = false;
        console.log('Failed! while trying to get the payment list.' + error.error);
      });
    }
  }

  getPaymentListFilterAndSearch() {
    this.spinnerService.show();
    this.pageStart = 0;
    this.pageIndex = 0;
    this.queryParams.pageIndex = this.pageIndex;
    this.queryParams.pageSize = this.pageSize;
    this.queryParams.startDate = this.pageStartDate;
    this.queryParams.endDate = this.pageEndDate;
    this.queryParams.type = this.Operation;
    if (this.searchValue != '') {
      this.queryParams.textSearch = this.searchValue;
    } else {
      const { textSearch, ...queryParamsObject } = this.queryParams;
      this.queryParams = queryParamsObject;
    }
    this.paginator.pageIndex = 0;
    this.setBackToSearchFilter();
    this.pageEvent(this.queryParams);
  }

  pageEvent(event) {
    this.spinnerService.show();
    this.pageSize = event.pageSize;
    this.pageStart = event.pageIndex * event.pageSize;
    this.pageIndex = event.pageIndex;

    this.queryParams.pageIndex = event["pageIndex"].toString();
    this.queryParams.pageSize = event["pageSize"].toString();

    if (event["startDate"]) {
      if (this.startDateFromSnapshotQueryParam == true) {
        this.queryParams.startDate = event["startDate"];
        this.pageStartDate = this.replaceAt(10, event["startDate"], ' ');
        this.startDateFromSnapshotQueryParam = false;
      } else {
        this.pageStartDate = event["startDate"];
        this.queryParams.startDate = event["startDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.startDate = this.pageStartDate;
      this.queryParams.startDate = this.queryParams.startDate.replace(' ', '-');
    };

    if (event["endDate"]) {
      if (this.endDateFromSnapshotQueryParam == true) {
        this.queryParams.endDate = event["endDate"];
        this.pageEndDate = this.replaceAt(10, event["endDate"], ' ');
        this.endDateFromSnapshotQueryParam = false;
      } else {
        this.pageEndDate = event["endDate"];
        this.queryParams.endDate = event["endDate"].replace(' ', '-');
      }
    } else {
      this.queryParams.endDate = this.pageEndDate;
      this.queryParams.endDate = this.queryParams.endDate.replace(' ', '-');
    };

    if (event["type"] && event["type"] != '') {
      this.queryParams.type = event["type"];
      this.Operation = this.queryParams.type == 'all' ? '' : this.queryParams.type;
    } else {
      if (this.Operation != '') {
        this.queryParams.type = this.Operation;
      } else {
        this.queryParams.type = 'all';
        this.Operation = '';
      }
    };

    if (event["textSearch"] != undefined) {
      this.queryParams.textSearch = event["textSearch"];
      this.searchValue = this.queryParams.textSearch;
    };

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: this.queryParams,
      skipLocationChange: false,
      replaceUrl: true
    });

    this.paymentProcessService.getPaymentProcessReportListNew(this.customer_public_id, this.pageStartDate,
      this.pageEndDate, this.pageSize, this.pageStart, this.searchValue, this.Operation).subscribe(data => {
        let resourcesReturn = data["data"];
        this.dataSourcePaymentsList.data = resourcesReturn;
        this.excelExporSize = data["records"];
        this.excelExportData = resourcesReturn;
        this.spinnerService.hide();
      }, error => {
        this.isLoading = false;
        console.log('Failed! while trying to get the payment list.' + error.error);
      });

    this.setBackToSearchFilter();
  }

  setTypeFormBySnapshotQueryParam(status) {
    switch (status) {
      case 'all':
        this.operationFormControl.setValue(0);
        break;
      case 'CREDIT':
        this.operationFormControl.setValue(1);
        break;
      case 'DEBIT':
        this.operationFormControl.setValue(2);
        break;
      default:
        this.operationFormControl.setValue(0);
    }
  }

  replaceAt(index, textToReplace, character) {
    let chars = textToReplace.split('');
    chars[index] = character;
    return chars.join('');
  }

  getCustomerAccountList() {

    this.customerService.getCustomerAccountList(this.customer_public_id).subscribe(data => {
      let resourcesReturn = data;
      this.ddlCustomerAccount = resourcesReturn;

      this.ddlCustomerAccount = this.ddlCustomerAccount.filter(t => t.type == 'COLLECT' || t.type == 'RECEIVABLE');

    },
      error => {
        console.log('Failed! while trying to get the account list.' + error.error);
      });
  }//end

  getCustomerPayment() {

    this.paymentProcessService.getPaymentProcessReportListPSP(this.customer_public_id).subscribe(data => {
      this.paymentPSP = data.values.value;

    },
      error => {
        this.paymentPSP = false;
        //return '';
        console.log('Failed! while trying to get. ' + error.error);
      });
  }//end

  filterTypeDetails(type) {
    this.operationDropdownValue = type;
    if (type == 1) {
      this.Operation = "CREDIT";
    } else if (type == 2) {
      this.Operation = "DEBIT";
    } else {
      this.Operation = '';
    }
    this.getPaymentListFilterAndSearch();
  }

  filterCreationDetails(creation) {
    this.creationDropdownValue = creation;

    if (creation != 7) {
      localStorage.setItem('creationStateReportsPaymentsList', creation);
    };

    var currentDate = new Date();
    var currentDate1 = new Date();

    var currentweekFirstDate = new Date();
    var currentweekLastDate = new Date();

    var lastweekFirstDate = new Date();
    var lastweekLastDate = new Date();

    currentweekFirstDate.setDate(currentweekFirstDate.getDate() - currentweekFirstDate.getDay());
    currentweekLastDate.setDate(currentweekFirstDate.getDate() + 7);

    var offset;

    var currentmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    var currentmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);

    var lastmonthFirstDate = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1);
    var lastmonthLastDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 0);

    lastweekFirstDate.setDate(lastweekFirstDate.getDate() - 7);
    lastweekLastDate.setDate(lastweekFirstDate.getDate() + 6);

    // All Datas Condition
    if (creation == 0) {
      var strStartDate;
      var strEndDate;
      strStartDate = "2017-01-01";
      strEndDate = "2030-01-01";
      this.pageStartDate = strStartDate;
      this.pageEndDate = strEndDate;
      //this.dataSourcePaymentsList.filter = '';
      // this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue,this.Operation);
      this.getPaymentListFilterAndSearch();
    }

    // Current Month Filter Condition
    if (creation == 1) {
      //this.dataSourcePaymentsList.filter = '';


      var CurrentmonthFirstDate1 = new Date(formatDate(currentmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let CurrentmonthFirstDate = this.convertGMTTime(CurrentmonthFirstDate1);

      var CurrentmonthEndDate1 = new Date(formatDate(currentmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let CurrentmonthEndDate = this.convertGMTTime(CurrentmonthEndDate1);

      this.pageStartDate = CurrentmonthFirstDate;
      this.pageEndDate = CurrentmonthEndDate;

      //this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue,this.Operation);
      this.getPaymentListFilterAndSearch();
    }

    // Current Week Filter Condition
    if (creation == 2) {
      //this.dataSourcePaymentsList.filter = '';

      var WeekstartDate1 = new Date(formatDate(currentweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let WeekstartDate = this.convertGMTTime(WeekstartDate1);

      var WeekendDate1 = new Date(formatDate(currentweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let WeekendDate = this.convertGMTTime(WeekendDate1);

      this.pageStartDate = WeekstartDate;
      this.pageEndDate = WeekendDate;

      //this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue,this.Operation);
      this.getPaymentListFilterAndSearch();
    }

    // Today Filter Condition
    if (creation == 3) {
      //this.dataSourcePaymentsList.filter = '';


      currentDate.setDate(currentDate.getDate());
      currentDate1.setDate(currentDate1.getDate());

      var todayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(todayStartDate);

      var todayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let endDate = this.convertGMTTime(todayEndDate);

      this.pageStartDate = startDate;
      this.pageEndDate = endDate;

      //this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue,this.Operation);
      this.getPaymentListFilterAndSearch();

    }

    // Yesterday Filter Condition
    if (creation == 4) {
      // this.dataSourcePaymentsList.filter = '';

      currentDate.setDate(currentDate.getDate() - 1);
      currentDate1.setDate(currentDate1.getDate() - 1);

      var yesterdayStartDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let startDate = this.convertGMTTime(yesterdayStartDate);

      var yesterdayEndDate = new Date(formatDate(currentDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let endDate = this.convertGMTTime(yesterdayEndDate);
      this.pageStartDate = startDate;
      this.pageEndDate = endDate;

      //this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue,this.Operation);
      this.getPaymentListFilterAndSearch();
    }


    // Last Week Filter Condition
    if (creation == 5) {
      //this.dataSourcePaymentsList.filter = '';

      var lastWeekstartDate1 = new Date(formatDate(lastweekFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let lastWeekstartDate = this.convertGMTTime(lastWeekstartDate1);

      var lastWeekendDate1 = new Date(formatDate(lastweekLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let lastWeekendDate = this.convertGMTTime(lastWeekendDate1);

      this.pageStartDate = lastWeekstartDate;
      this.pageEndDate = lastWeekendDate;

      //this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue, this.Operation);
      this.getPaymentListFilterAndSearch();

    }

    // Last Month Filter Condition
    if (creation == 6) {
      //this.dataSourcePaymentsList.filter = '';

      var LastmonthFirstDate1 = new Date(formatDate(lastmonthFirstDate, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let LastmonthFirstDate = this.convertGMTTime(LastmonthFirstDate1);

      var LastmonthEndDate1 = new Date(formatDate(lastmonthLastDate, 'yyyy-MM-dd 23:59:59', 'en-US'));
      let LastmonthEndDate = this.convertGMTTime(LastmonthEndDate1);

      this.pageStartDate = LastmonthFirstDate;
      this.pageEndDate = LastmonthEndDate;

      //this.getCustomerPaymentsListNew(this.customer_public_id, this.pageStartDate, this.pageEndDate, this.pageSize, 0, this.searchValue, this.Operation);
      this.getPaymentListFilterAndSearch();
    }


    // Range Filter Condition
    if (creation == 7) {
      this.isRangoVisiable = true;
    }
    else {
      this.isRangoVisiable = false;
    }

    if (creation == 8) {
      this.filterRangoDetails()
    }
    this.setBackToSearchFilter();
  }//end



  filterAccountDetails(account) {
    // All Datas Condition
    if (account == 0) {
      this.dataSourcePaymentsList.filter = '';
    }

    if (account != 0) {
      this.dataSourcePaymentsList.filterPredicate = (data: PaymentProcess, filter: string) =>
        data.invoice_list[0].name == account;

      this.dataSourcePaymentsList.filter = account;
    }
  }//end

  filterRangoDetails() {

    if (this.paymentCreation._creation.length > 8) {
      this.paymentCreation._creation.shift();
    }

    if (this.searchRangoFilterForm.controls.searchFromDate.value !== null && this.searchRangoFilterForm.controls.searchToDate.value !== null
      && this.searchRangoFilterForm.controls.searchFromDate.value != '' && this.searchRangoFilterForm.controls.searchToDate.value != '') {
      localStorage.setItem('creationStateReportsPaymentsList', '8');
      this.filterValue = this.datePipe.transform(this.searchRangoFilterForm.controls.searchFromDate.value, "dd/MM/yyyy") + '-' + this.datePipe.transform(this.searchRangoFilterForm.controls.searchToDate.value, "dd/MM/yyyy");
      localStorage.setItem('customCreationReportsPaymentsRange', this.filterValue);
      this.ddlPaymentCreation.unshift({ value: 8, name: this.filterValue });
      this.isRangoVisiable = false;
      let CurrentmonthFirstDate = new Date(formatDate(this.searchRangoFilterForm.controls.searchFromDate.value, 'yyyy-MM-dd 00:00:00', 'en-US'));
      let CurrentmonthEndDate = new Date(formatDate(this.searchRangoFilterForm.controls.searchToDate.value, 'yyyy-MM-dd 23:59:59', 'en-US'));
      this.pageStartDate = this.convertGMTTime(CurrentmonthFirstDate);
      this.pageEndDate = this.convertGMTTime(CurrentmonthEndDate);
      this.creationFormControl.setValue(8);
      this.creationDropdownValue = 8;
    } else {
      localStorage.setItem('creationStateReportsPaymentsList', '3');
      this.isRangoVisiable = false;
      this.creationFormControl.setValue(3);
      this.creationDropdownValue = 3;
      this.pageStartDate = this.setTodayValueFilter('00:00:00');
      this.pageEndDate = this.setTodayValueFilter('23:59:59');
    }
    this.getPaymentListFilterAndSearch();
  }

  paymentgridActionClick(viewtype, publicid) {

    switch (viewtype) {
      case 'paymentview':
        this.router.navigate([`/payments/${publicid}/view`]);
        break;
      case 'paymentedit':
        this.router.navigate([`/payments/${publicid}/edit`]);
        break;

      default:
        this.router.navigate([`/payments/${publicid}/view`]);

    }//end switch

  }//end

  checkResponseExportTime() {
    this.timerId = setTimeout(() => {
      if (this.isExportDataAvailable == undefined && this.isErrorExportAvailable == undefined) {
        this.spinnerService.hide();
        this.timeCompleted = true;
        this.exportSubscription$.unsubscribe();
      }
    }, 10000);
  }

  reportExport(templateValue?: string) {
    this.spinnerService.show();
    clearTimeout(this.timerId);
    this.isExportDataAvailable = undefined;
    this.isErrorExportAvailable = undefined;

    let template: string;
    if (this.isExportTemplateNotAvailable) {
      template = "PAYMENT_STANDARD";
    } else {
      template =  templateValue;
    }
    this.checkResponseExportTime();
    this.exportSubscription$ = this.paymentProcessService.reportExport(this.customer_public_id, this.pageStartDate,
      this.pageEndDate, this.Operation, this.searchValue, template).subscribe(data => {
      this.isExportDataAvailable = data;
      if (data.storage_url != undefined) {
        location.href = data.storage_url;
      } else {
        console.log(data);
      }
      this.spinnerService.hide();
    }, err => {
      this.spinnerService.hide();
      this.isErrorExportAvailable = err;
      console.log('Failed while trying to export file.' + err.error);
    });
  }

  closeModal() {
    this.timeCompleted = false;
  };

  setExportExcelFileData(excelExportData) {
    var excelHeader;
    //  if (this.paymentPSP === false) {
    //    excelHeader = ["Fecha de Registro", "Referencia de Pago", "Cliente", "Cliente Id", "Referencia de Orden",
    //   "Descripción", "Moneda","Subtotal", "Mora", "Total", "Método de Pago"]
    //   } else {
    //      excelHeader = ["Fecha de Registro", "Referencia de Pago", "Cliente", "Cliente Id", "Referencia de Orden",
    //     "Descripción", "Código de Pago", "Moneda","Subtotal", "Mora", "Total", "Método de Pago"]
    //   }
    excelHeader = ["FECHA DE REGISTRO", "REFERENCIA DE PAGO", "CLIENTE", "REFERENCIA DE ORDEN", "DESCRIPCIÓN", "MONEDA", "SUBTOTAL", "MORA", "TOTAL", "MÉTODO DE PAGO", "OPERACIÓN"]
    var arrFinalData = [];
    var object_temp = {};
    var i = 0;
    var columnsKeyNames = [];

    for (i = 0; i < excelExportData.length; i++) {
      var singleRec_temp = excelExportData[i];
      delete singleRec_temp['public_id'];
      delete singleRec_temp['livemode'];
      delete singleRec_temp['object'];
      delete singleRec_temp['status'];


      columnsKeyNames = Object.keys(singleRec_temp);



      var created_temp;
      var reference_temp;
      var customer_temp;
      var customer_temp_id;
      var external_id_temp;
      var name_temp;
      var sub_total_temp;
      var late_fee_temp;
      var total_temp;
      var sub_total_temp_symbol;
      var psp_name_temp;
      var psp_account_name_temp;
      var operation_temp;
      object_temp = {};

      for (var j = 0; j < columnsKeyNames.length; j++) {

        if (columnsKeyNames[j] == "created") {
          created_temp = singleRec_temp[columnsKeyNames[j]];
        }

        if (columnsKeyNames[j] == "reference") {
          reference_temp = singleRec_temp[columnsKeyNames[j]];
        }

        if (columnsKeyNames[j] == "customer") {
          customer_temp = singleRec_temp[columnsKeyNames[j]].name;
          customer_temp_id = singleRec_temp[columnsKeyNames[j]].public_id;
        }

        if (columnsKeyNames[j] == "invoice_list") {
          external_id_temp = singleRec_temp[columnsKeyNames[j]][0].external_id;
          name_temp = singleRec_temp[columnsKeyNames[j]][0].name;
          sub_total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[j]][0].sub_total.value, "", "");
          late_fee_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[j]][0].late_fee.value, "", "");
          total_temp = this.currencyPipe.transform(singleRec_temp[columnsKeyNames[j]][0].total.value, "", "");

          sub_total_temp_symbol = singleRec_temp[columnsKeyNames[j]][0].total.currency;
          if (this.paymentPSP === true) {
            psp_name_temp = singleRec_temp[columnsKeyNames[j]][0].psp_tin;
          }

        }

        if (columnsKeyNames[j] == "metadata") {
          psp_account_name_temp = singleRec_temp[columnsKeyNames[j]].psp_account.name;
          var type = singleRec_temp[columnsKeyNames[j]].type;
          if (type == 'CREDIT') {
            operation_temp = 'Pago';
          } else if (type == 'DEBIT') {
            operation_temp = 'Reverso';
          } else {
            operation_temp = type;
          }
        }
      }

      arrFinalData.push([this.excelDateConvertService.convertExcelDateTime(created_temp), reference_temp, customer_temp, external_id_temp, name_temp, sub_total_temp_symbol
        , sub_total_temp, late_fee_temp, total_temp, psp_account_name_temp, operation_temp]);
      // for (var k = 0; k < excelHeader.length; k++) {
      //   if (excelHeader[k] == "Fecha de Registro") {
      //     object_temp[excelHeader[k]] = this.convertExcelGMTTime(created_temp);
      //   }
      //   if (excelHeader[k] == "Referencia de Pago") {
      //     object_temp[excelHeader[k]] = reference_temp;
      //   }
      //   if (excelHeader[k] == "Cliente") {
      //     object_temp[excelHeader[k]] = customer_temp;
      //   }

      //   if (excelHeader[k] == "Referencia de Orden") {
      //     object_temp[excelHeader[k]] = external_id_temp;
      //   }
      //   if (excelHeader[k] == "Descripción") {
      //     object_temp[excelHeader[k]] = name_temp;
      //   }
      //   // if (this.paymentPSP === true) {
      //   //   if (excelHeader[k] === "Código de Pago") {
      //   //     object_temp[excelHeader[k]] = psp_name_temp;
      //   //   }
      //   // }
      //   if (excelHeader[k] == "Moneda") {
      //     object_temp[excelHeader[k]] = sub_total_temp_symbol;
      //   }
      //   if (excelHeader[k] == "Subtotal") {
      //     object_temp[excelHeader[k]] = sub_total_temp;
      //   }
      //   if (excelHeader[k] == "Mora") {
      //     object_temp[excelHeader[k]] = late_fee_temp;
      //   }
      //   if (excelHeader[k] == "Total") {
      //     object_temp[excelHeader[k]] = total_temp;
      //   }

      //   if (excelHeader[k] == "Método de Pago") {
      //     object_temp[excelHeader[k]] = psp_account_name;
      //   }

      // }

      //arrFinalData.push(object_temp);

    }



    this.excelService.generatePaymentListExcel(excelHeader, arrFinalData);
    this.spinnerService.hide();

  }//end function

  convertGMTTime(startDate1) {
    if (this.offsetTimeZone > 0) {
      let date: any = new Date(startDate1);
      var dateTimeZoneDiff = new Date(date);
      dateTimeZoneDiff.setMilliseconds(Number(this.offsetTimeVal));
      let startDate = formatDate(dateTimeZoneDiff, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }
    else {
      var startDate2 = new Date(startDate1.setHours(startDate1.getHours() - this.offsetTimeZone));
      var startDate3 = new Date(startDate2.setMinutes(startDate2.getMinutes() - this.offsetMinutes));
      let startDate = formatDate(startDate3, 'yyyy-MM-dd HH:mm:ss', 'en-US');
      return startDate;
    }

  }

  //   convertExcelGMTTime(value) {
  //   var dateTimeZoneDiff = value.split(/[- :]/),
  //   dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  //   dateFinal.setMilliseconds(Number(this.offsetTimeVal));
  //   var dateString = moment(dateFinal).format('MM/DD/YYYY HH:mm:ss');
  //   var dateObj = new Date(dateString);
  //   var momentObj = moment(dateObj);
  //   var momentString = momentObj.format('YYYY-MM-DD HH:mm:ss'); // 2016-07
  //   return momentString;
  // }

  // convertExcelGMTTime(value) {
  //   var dateTimeZoneDiff = value.split(/[- :]/),
  //     dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
  //   dateFinal.setMilliseconds(Number(this.offsetTimeVal));
  //   var dateString = moment(dateFinal).format('MM/DD/YYYY HH:mm:ss');
  //   var dateObj = new Date(dateString);
  //   var momentObj = moment(dateObj);
  //   var momentString = momentObj.format('DD/MM/YYYY HH:mm:ss'); // 2016-07
  //   return momentString;
  // }

  modelData(data) {
    this.payment_related = data.metadata.payment_related;
  }

  customerView(id) {
    this.close.nativeElement.click();
    setTimeout(() => {
      this.router.navigate([`/customers/${id}/view`]);
    }, 500)
  }

  invoiceView(id) {
    this.close.nativeElement.click();
    setTimeout(() => {
      this.viewInvoiceDetails(id);
    }, 500)
  }

  viewInvoiceDetails(element) {
    const application = localStorage.getItem('application');
    if (AccountTypeOptions[application] != undefined) {
      this.router.navigate([`/${AccountTypeOptions[application]}/invoices/${element}/view`]);
    }
  }

  setBackToSearchFilter() {
    this.tempSearch = {
      search: this.searchValue,
      creationStartDate: this.pageStartDate,
      creationEndDate: this.pageEndDate,
      operation: this.Operation,
      operationDropdownValue: this.operationDropdownValue,
      creationDropdownValue: this.creationDropdownValue,
      searchFromDate: this.searchRangoFilterForm.controls.searchFromDate.value,
      searchToDate: this.searchRangoFilterForm.controls.searchToDate.value,
      pageSize: this.pageSize,
      pageIndex: this.pageIndex,
      pageStart: this.pageStart
    }
    this.backFilterService.setPaymentSearchSharedData(this.tempSearch);
  }

}//end class


